(function () {
  const storageKey = 'gam-theme-mode';
  const darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  const root = document.documentElement;

  function resolveMode(mode) {
    if (mode === 'dark' || mode === 'light') return mode;
    return darkMediaQuery.matches ? 'dark' : 'light';
  }

  function getCurrentMode() {
    const mode = root.getAttribute('data-theme-mode');
    if (mode === 'light' || mode === 'dark' || mode === 'system') return mode;
    return 'system';
  }

  function setMode(mode, options = {}) {
    const persist = options.persist !== false;
    const normalizedMode = mode === 'dark' || mode === 'light' ? mode : 'system';
    const appliedMode = resolveMode(normalizedMode);

    root.setAttribute('data-theme-mode', normalizedMode);
    root.setAttribute('data-theme', appliedMode);
    root.classList.toggle('theme-dark', appliedMode === 'dark');
    root.classList.toggle('theme-light', appliedMode !== 'dark');

    if (persist) {
      try {
        localStorage.setItem(storageKey, normalizedMode);
      } catch (error) {
        // Ignore storage failures in private mode/restricted contexts.
      }
    }

    updateToggleButtons(normalizedMode, appliedMode);
  }

  function getNextMode() {
    const appliedMode = root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    return appliedMode === 'dark' ? 'light' : 'dark';
  }

  function updateToggleButtons(mode, appliedMode) {
    const isDark = appliedMode === 'dark';
    const labels = {
      current: isDark ? 'Dark Mode aktiv' : 'Light Mode aktiv',
      action: isDark ? 'Zu Light Mode wechseln' : 'Zu Dark Mode wechseln',
      mode: mode,
    };

    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', labels.action);
      button.setAttribute('data-theme-toggle-state', isDark ? 'dark' : 'light');
      button.setAttribute('data-theme-toggle-mode', labels.mode);

      const textTarget = button.querySelector('[data-theme-toggle-label]');
      if (textTarget) {
        textTarget.textContent = labels.current + '. ' + labels.action;
      }
    });
  }

  function onToggleClick(event) {
    event.preventDefault();
    setMode(getNextMode(), { persist: true });
  }

  function bindToggleButtons() {
    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      if (button.dataset.themeToggleBound === 'true') return;
      button.dataset.themeToggleBound = 'true';
      button.addEventListener('click', onToggleClick);
    });
  }

  function initializeMode() {
    let savedMode = '';

    try {
      savedMode = localStorage.getItem(storageKey) || '';
    } catch (error) {
      savedMode = '';
    }

    const mode = savedMode === 'light' || savedMode === 'dark' || savedMode === 'system' ? savedMode : getCurrentMode();
    setMode(mode, { persist: false });
  }

  const systemModeListener = () => {
    if (getCurrentMode() === 'system') {
      setMode('system', { persist: false });
    }
  };

  if (typeof darkMediaQuery.addEventListener === 'function') {
    darkMediaQuery.addEventListener('change', systemModeListener);
  } else if (typeof darkMediaQuery.addListener === 'function') {
    darkMediaQuery.addListener(systemModeListener);
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindToggleButtons();
    initializeMode();
  });

  document.addEventListener('shopify:section:load', () => {
    bindToggleButtons();
    updateToggleButtons(getCurrentMode(), resolveMode(getCurrentMode()));
  });
})();
